export default __webpack_public_path__ + "static/media/back.e1f5831d.svg";